import { makeStyles } from "tss-react/mui";
import { IFieldSetStackedField, IMenuItemConfig } from "@miplatform/types";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { MiFieldSetStacked } from "../MiFieldSet/MiFieldSetStacked";
import { MiMenu } from "../MiMenu/MiMenu";

export const MiWorkListCard = <T,>({
  item,
  renderTitle,
  title,
  subtitle,
  renderItemActions,
  fieldset,
  fieldsetStyle,
  showNulls,
  cardContainerStyles,
  LeftComponent,
  RightComponent,
  menuActions,
  getMenuItems,
}: IMiWorkListCardProps<T>) => {
  const { classes } = useStyles();

  const menuItems = getMenuItems ? getMenuItems(item) : menuActions;

  return (
    <Box className={classes.cardContainer} style={cardContainerStyles}>
      <Box className={classes.cardLeft}>
        {LeftComponent && <LeftComponent item={item} />}
        <Box>
          {renderTitle ? (
            renderTitle(item)
          ) : (
            <Box className={classes.cardHeader}>
              <Typography variant="HD2">{title}</Typography>
              {subtitle && <Typography variant="HD4">{subtitle}</Typography>}
            </Box>
          )}
        </Box>
      </Box>
      <Box className={classes.cardRight}>
        {fieldset && (
          <MiFieldSetStacked
            row={item}
            fieldset={fieldset}
            fieldsetStyle={fieldsetStyle}
            showNulls={showNulls}
          />
        )}
        {RightComponent && <RightComponent item={item} />}
        <Box className={classes.actionContainer}>
          {renderItemActions && renderItemActions(item)}
          {menuItems && <MiMenu data={menuItems} />}
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey.lightAccent}`,
    borderRadius: 4,
    padding: theme.spacing(1),
    width: "100%",
    boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.12)",
  },
  cardLeft: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
    flex: 1,
  },
  cardHeader: {},
  cardRight: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
  },
  actionContainer: {
    display: "flex",
    alignItems: "center",
  },
}));

interface IMiWorkListCardProps<T> {
  item: T;
  fieldset?: Array<IFieldSetStackedField<T>>;
  renderTitle?: (item: T) => React.ReactNode;
  renderItemActions?: (item: T) => React.ReactNode;
  cardContainerStyles?: React.CSSProperties;
  menuActions?: Array<IMenuItemConfig>;
  title?: string;
  subtitle?: string;
  showNulls?: boolean;
  fieldsetStyle?: React.CSSProperties;
  LeftComponent?: React.ComponentType<{ item: T }>;
  RightComponent?: React.ComponentType<{ item: T }>;
  getMenuItems?: (item: T) => Array<IMenuItemConfig>;
}
